<template>
  <div class="card mb-3" style="overflow: hidden">
    <div
      :id="`${group.value}Heading`"
      class="card-header bg-dark text-white p-2"
      @click="onSelect"
    >
      <h5 class="mb-0">
        <button
          :class="{ collapsed: isCollapsed }"
          class="btn btn-link text-white font-main font-weight-bold btn-accord"
          :aria-expanded="!isCollapsed"
        >
          <span v-if="selectedChildrenCount" class="active-options">
            {{ selectedChildrenCount }}
          </span>
          {{ group.name }}
        </button>
      </h5>
    </div>
    <transition name="accordion-fade-slide" mode="out-in">
      <div
        v-show="!isCollapsed"
        :id="`${group.value}Filter`"
        :aria-labelledby="`${group.value}Heading`"
      >
        <slot :id="group.value" name="filter" />
      </div>
    </transition>
  </div>
</template>

<script>
export default {
  name: 'FilterGroup',

  props: {
    /** @type {import('vue').PropOptions<import('./store/state').FacetGroup>} */
    group: {
      type: Object,
      required: true,
    },
    isCollapsed: {
      type: Boolean,
      required: true,
    },
  },

  computed: {
    /** @returns {number} */
    selectedChildrenCount() {
      return this.group.facets.reduce((prev, curr) => {
        if (curr.isSelected) {
          prev++;
        }

        return prev;
      }, 0);
    },
  },

  methods: {
    onSelect() {
      this.$emit('select', {
        isCollapsed: this.isCollapsed,
        groupId: this.group.value,
      });
    },
  },
};
</script>

<style lang="scss" scoped>
@import '@/src/styles/variables';

.active-options {
  position: relative;
  transform: translateY(0px);
  left: -5px;
  background-color: rgba(255, 255, 255, 0.15);
  border: 2px solid $white;
  border-radius: 50%;
  display: inline-block;
  box-sizing: border-box;
  width: 22px;
  height: 22px;
  padding: 2px 0 0 0;
  text-align: center;
  font-family: 'Montserrat', sans-serif;
  font-weight: 800;
  font-size: 14px;
  line-height: 1;
}

.accordion-fade-slide {
  &-enter-active,
  &-leave-active {
    transition: all 0.75s;
  }
  &-enter {
    height: 0;
    opacity: 0;
  }
  &-enter-to {
    max-height: 390px;
    overflow: hidden;
    opacity: 1;
  }
  &-leave {
    max-height: 390px;
    overflow: hidden;
    opacity: 1;
  }
  &-leave-to {
    height: 0px;
    opacity: 0;
  }
}
</style>
